const BASE_URL = '/promotions';

export const PROMOTIONS_ROUTES = {
  promotionsList: BASE_URL,
  newPromotions: `${BASE_URL}/new`,
  editPromotions: `${BASE_URL}/edit/:id`,
};
